// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cash-drawer-modal-container {
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 380px;
  border-radius: 24px;
  overflow: hidden;
  border: none;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1400;
  background-color: #ffffff;
  box-sizing: border-box;
}

/* Header styling */
.cash-drawer-header {
  background-color: #0f172a;
  padding: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cash-drawer-icon-wrap {
  width: 64px;
  height: 64px;
  background-color: #1e293b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border: 1px solid #334155;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
}

.cash-drawer-lock-icon {
  width: 32px;
  height: 32px;
  color: #60a5fa;
}

.cash-drawer-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0 0 4px 0 !important;
  text-transform: none !important;
}

.cash-drawer-subtitle {
  font-size: 0.875rem;
  color: #94a3b8;
  margin: 0;
  font-weight: 400;
}

/* Body and form styling */
.cash-drawer-body {
  padding: 24px;
  background-color: #ffffff;
}

.cash-drawer-modal-container.dark .cash-drawer-body {
  background-color: #1e293b;
}

.cash-drawer-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.cash-drawer-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cash-drawer-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}

.cash-drawer-modal-container.dark .cash-drawer-label {
  color: #94a3b8;
}

/* Custom MUI Dropdown styling */
.cash-drawer-select {
  border-radius: 12px !important;
  font-size: 0.875rem !important;
  background-color: transparent;
  height: 44px;
}

.cash-drawer-select .MuiOutlinedInput-notchedOutline {
  border-color: #e2e8f0 !important;
  border-width: 1px !important;
}

.cash-drawer-select:hover .MuiOutlinedInput-notchedOutline {
  border-color: #cbd5e1 !important;
}

.cash-drawer-select.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #2563eb !important;
  border-width: 1px !important;
}

.cash-drawer-modal-container.dark .cash-drawer-select {
  color: #ffffff !important;
}

.cash-drawer-modal-container.dark .cash-drawer-select .MuiOutlinedInput-notchedOutline {
  border-color: #475569 !important;
}

.cash-drawer-modal-container.dark .cash-drawer-select:hover .MuiOutlinedInput-notchedOutline {
  border-color: #64748b !important;
}

.cash-drawer-modal-container.dark .cash-drawer-select.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #3b82f6 !important;
}

.cash-drawer-select .MuiSelect-select {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.cash-drawer-placeholder {
  color: #94a3b8;
}

.cash-drawer-modal-container.dark .cash-drawer-select .MuiSvgIcon-root {
  color: #94a3b8;
}

/* Premium standard input styling */
.cash-drawer-input-wrapper {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 12px;
  height: 44px;
  background-color: transparent;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.cash-drawer-input-wrapper:hover {
  border-color: #cbd5e1;
}

.cash-drawer-input-wrapper:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}

.cash-drawer-modal-container.dark .cash-drawer-input-wrapper {
  border-color: #475569;
}

.cash-drawer-modal-container.dark .cash-drawer-input-wrapper:hover {
  border-color: #64748b;
}

.cash-drawer-modal-container.dark .cash-drawer-input-wrapper:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

.cash-drawer-input {
  width: 100%;
  height: 100%;
  font-size: 0.875rem !important;
  background: transparent !important;
  border: none !important;
  color: #0f172a !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.cash-drawer-modal-container.dark .cash-drawer-input {
  color: #ffffff !important;
}

.cash-drawer-modal-container.dark .cash-drawer-input-wrapper .MuiSvgIcon-root {
  color: #94a3b8;
}

/* Action button styling */
.cash-drawer-submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 12px;
  color: #ffffff;
  border: 1px solid #2563eb;
  background-color: #2563eb;
  box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.2), 0 4px 6px -4px rgba(37, 99, 235, 0.2);
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s, transform 0.1s, box-shadow 0.15s;
}

.cash-drawer-submit-btn:hover:not(:disabled) {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
  box-shadow: 0 10px 20px -3px rgba(37, 99, 235, 0.3), 0 4px 8px -4px rgba(37, 99, 235, 0.3);
}

.cash-drawer-submit-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.cash-drawer-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

/* Close button styling */
.cash-drawer-close-btn {
  position: absolute;
  right: 16px;
  top: 16px;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: #94a3b8;
  opacity: 0.7;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  transition: opacity 0.15s, color 0.15s, background-color 0.15s;
}

.cash-drawer-close-btn:hover {
  opacity: 1;
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
}

.cash-drawer-close-icon {
  width: 16px;
  height: 16px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/CashDrawerModal/CashDrawerModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iDAAiD;EACjD,uFAAuF;EACvF,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,2CAA2C;EAC3C,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,0FAA0F;EAC1F,eAAe;EACf,wFAAwF;AAC1F;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0FAA0F;AAC5F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,8DAA8D;AAChE;;AAEA;EACE,UAAU;EACV,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".cash-drawer-modal-container {\n  display: flex;\n  flex-direction: column;\n  width: 90%;\n  max-width: 380px;\n  border-radius: 24px;\n  overflow: hidden;\n  border: none;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1400;\n  background-color: #ffffff;\n  box-sizing: border-box;\n}\n\n/* Header styling */\n.cash-drawer-header {\n  background-color: #0f172a;\n  padding: 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.cash-drawer-icon-wrap {\n  width: 64px;\n  height: 64px;\n  background-color: #1e293b;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  border: 1px solid #334155;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);\n}\n\n.cash-drawer-lock-icon {\n  width: 32px;\n  height: 32px;\n  color: #60a5fa;\n}\n\n.cash-drawer-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff !important;\n  margin: 0 0 4px 0 !important;\n  text-transform: none !important;\n}\n\n.cash-drawer-subtitle {\n  font-size: 0.875rem;\n  color: #94a3b8;\n  margin: 0;\n  font-weight: 400;\n}\n\n/* Body and form styling */\n.cash-drawer-body {\n  padding: 24px;\n  background-color: #ffffff;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-body {\n  background-color: #1e293b;\n}\n\n.cash-drawer-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.cash-drawer-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.cash-drawer-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 4px;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-label {\n  color: #94a3b8;\n}\n\n/* Custom MUI Dropdown styling */\n.cash-drawer-select {\n  border-radius: 12px !important;\n  font-size: 0.875rem !important;\n  background-color: transparent;\n  height: 44px;\n}\n\n.cash-drawer-select .MuiOutlinedInput-notchedOutline {\n  border-color: #e2e8f0 !important;\n  border-width: 1px !important;\n}\n\n.cash-drawer-select:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #cbd5e1 !important;\n}\n\n.cash-drawer-select.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #2563eb !important;\n  border-width: 1px !important;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-select {\n  color: #ffffff !important;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-select .MuiOutlinedInput-notchedOutline {\n  border-color: #475569 !important;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-select:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #64748b !important;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-select.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #3b82f6 !important;\n}\n\n.cash-drawer-select .MuiSelect-select {\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n\n.cash-drawer-placeholder {\n  color: #94a3b8;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-select .MuiSvgIcon-root {\n  color: #94a3b8;\n}\n\n/* Premium standard input styling */\n.cash-drawer-input-wrapper {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0 12px;\n  height: 44px;\n  background-color: transparent;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.cash-drawer-input-wrapper:hover {\n  border-color: #cbd5e1;\n}\n\n.cash-drawer-input-wrapper:focus-within {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 1px #2563eb;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-input-wrapper {\n  border-color: #475569;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-input-wrapper:hover {\n  border-color: #64748b;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-input-wrapper:focus-within {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n\n.cash-drawer-input {\n  width: 100%;\n  height: 100%;\n  font-size: 0.875rem !important;\n  background: transparent !important;\n  border: none !important;\n  color: #0f172a !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-input {\n  color: #ffffff !important;\n}\n\n.cash-drawer-modal-container.dark .cash-drawer-input-wrapper .MuiSvgIcon-root {\n  color: #94a3b8;\n}\n\n/* Action button styling */\n.cash-drawer-submit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 48px;\n  font-size: 1rem;\n  font-weight: 700;\n  border-radius: 12px;\n  color: #ffffff;\n  border: 1px solid #2563eb;\n  background-color: #2563eb;\n  box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.2), 0 4px 6px -4px rgba(37, 99, 235, 0.2);\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s, transform 0.1s, box-shadow 0.15s;\n}\n\n.cash-drawer-submit-btn:hover:not(:disabled) {\n  background-color: #1d4ed8;\n  border-color: #1d4ed8;\n  box-shadow: 0 10px 20px -3px rgba(37, 99, 235, 0.3), 0 4px 8px -4px rgba(37, 99, 235, 0.3);\n}\n\n.cash-drawer-submit-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.cash-drawer-submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* Close button styling */\n.cash-drawer-close-btn {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: #94a3b8;\n  opacity: 0.7;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  transition: opacity 0.15s, color 0.15s, background-color 0.15s;\n}\n\n.cash-drawer-close-btn:hover {\n  opacity: 1;\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.cash-drawer-close-icon {\n  width: 16px;\n  height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
